/**
 * Wix keeps reporting the last plan that was on an instance after the
 * subscription lapses, so `plan` alone does not mean "currently paying".
 * Every paid count in the dashboard has to check `expires_on` as well.
 */

/** A plan value that stands for an actual purchase rather than the free tier. */
export const isPaidPlan = (plan) =>
  Boolean(plan) && plan !== "—" && String(plan).toLowerCase() !== "free";

/**
 * Parses `expires_on` into a Date, or null when it is missing or unusable.
 * A missing expiry is not treated as expired — plans with no term recorded
 * keep counting rather than silently disappearing from the paid list.
 */
export const getExpiryDate = (installation) => {
  const value = installation?.expires_on;
  if (!value || value === "—") return null;
  const date = new Date(value);
  return isNaN(date.getTime()) ? null : date;
};

/** True once the expiry date and time has passed. */
export const isExpired = (installation, now = Date.now()) => {
  const expiry = getExpiryDate(installation);
  return expiry !== null && expiry.getTime() <= now;
};

/** True while the site is on a paid plan that has not lapsed yet. */
export const isActivePaid = (installation, now = Date.now()) =>
  isPaidPlan(installation?.plan) && !isExpired(installation, now);
